<template>
  <div>
    <Header state="add" />
    <CustomCoinForm />
  </div>
</template>

<script>
import Router from '@/router';
import Service from '@/service';
import Header from '@/components/header/Header';
import CustomCoinForm from '@/components/form/CustomCoinForm';

export default {
  name: 'AddCustomCoin',
  components: {
    Header,
    CustomCoinForm,
  },
  data() {
    return {
      validForm: false,
      userInputs: {},
    };
  },
  methods: {
    addCoin() {
      if (this.validForm) {
        const coin = {
          name: this.userInputs.name,
          code: this.userInputs.code,
          amount: this.userInputs.amount,
          purchasePrice: this.userInputs.purchasePrice,
          purchaseCurrency: 'GBP',
        };

        Service.addPurchase(Object.assign({}, coin));
        Router.push({ name: 'Account' });
      }
    },
    isFormValid() {
      const hasUserData = this.userInputs && this.userInputs.name && this.userInputs.code && this.userInputs.amount && this.userInputs.purchasePrice;
      if (hasUserData) {
        this.validForm = true;
      } else {
        this.validForm = false;
      }
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/view/AddCustomCoin.vue